<style>
  .feather-icon{
    line-height: 24px;
    vertical-align: middle;
  }
</style>
<template>
  <div class="device-info" :class="[`${custom}`]">
    <div class="shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle"  :class="[`bg-${status}`]" >
      <iconBase iconName="on" :width="18" :height="18" iconColor="#ffff" class="align-middle" v-if="status == 'success'"><iconOn/></iconBase>
      <iconBase iconName="off" :width="18" :height="18" iconColor="#ffff" class="align-middle" v-else-if="status == 'danger'"><iconOff/></iconBase>
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white stroke-current" v-else />
    </div>
    <span v-show="description.length > 0" class="ml-2 text-xs align-middle">{{description}}</span>
  </div>
</template>
<script>
import iconBase from '@/components/icons/iconBase'
import iconOn from '@/components/icons/iconOn'
import iconOff from '@/components/icons/iconOff'

export default {
  components: {
    iconBase,
    iconOn,
    iconOff
  },
  props:{
    status: String,
    custom: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>